/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Represents the type of Tag that can be associated with an object.
 */ 
export enum TagType {
    Assessment = 0,
    Room = 1,
    Other = 2,
    Scenario = 3,
    Event = 4,
    Recording = 5,
    SimUser = 6,
    ExamFlow = 7,
}
